export const getFilters = (state) => (key) => state.filters[key] || {}
